import "../../css/about.css"
function AboutOurStory() 
{
    return (
        <>
        <div className="container">
            <div>
                <h2 className="about-subtitle"> OUR STORY </h2>
            </div>

            <div className="bar"></div>

            <div>
                <h5 className="about-body">
                    <i>We are a campus chapter at the University of Southern California of the nonprofit organization Dear Asian Youth, dedicated to uplifting and empowering the narratives of Asian youth across the globe.</i>
                </h5>
            </div>

            <div className="bar"></div>

            <div>
                <p className="about-body">
                    This is a space for anyone who identifies as Asian Pacific Islander Desi American (APIDA) to share their stories and voice–to talk about your triumphs, your struggles, what makes you you, what makes up your world. Even if you don’t identify as APIDA, you are always welcome here; we are an inclusive space striving to uplift marginalized communities through creativity, education, and meaningful discussion.
                </p>
            </div>

            <div>
                <p className="about-body">
                    At the beginning of the pandemic, I suddenly found myself surrounded not by the busy bustle of what I expected in my senior year, but the silence and boredom of my bedroom. Eager to exercise my creative juices, I came across Dear Asian Youth (back then, just a blog started by my former classmate, Stephanie Hu, for Asian youth to share their writing). I submitted one prose piece detailing my struggles growing up Asian American, and pretty soon, found myself as a writer on a full-fledged literature staff.
                </p>
            </div>

            <div>
                <p className="about-body">
                    I was inspired by the family of passionate individuals working with me who, no matter which background, were dedicated to sharing their stories, celebrating each other, and educating the world on important matters surrounding social justice and civic engagement. When Dear Asian Youth finally became a registered nonprofit and started opening community and school chapters around the globe I knew I wanted to bring a similar space to USC…   
                </p>
            </div>

            <div>
                <p className="about-body">
                    …which brings us to now. I’m so happy you’re here. I hope you’ll stay around, and whether you decide to join our rapidly growing family or simply want to look around, I hope you’ll take with you the same amount of joy and growth from the pieces by our talented writers and illustrators as I do.
                </p>
            </div>

            <h5 className="about-subtitle2" style={{textAlign:'right'}}> 
                    -Yi-Ann (Former Chapter President) 
            </h5>

            <div className="bar"></div>

            <div>
                
            </div>

        </div>
        </>
    );
}

export default AboutOurStory;